<template>
  <el-dialog
    width="40%"
    :title="!dataForm.taskId ? '新增' : '任务详情'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
      class="form"
    >
      <el-form-item label="banner名称" prop="bannerName">
        <el-input v-model="dataForm.bannerName"  maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="图片上传" prop="bannerImg">
        <single-image @submit="getImgUrl"></single-image>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">返回</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { bannerSaveData } from '../api';
import SingleImage from '@/components/Upload/SingleImage.vue';
export default {
  components:{
    SingleImage
  },
  data() {
    return {
      visible: false,
      dataForm: {
        bannerName: "",
        bannerImg: "",
      },
    };
  },
  methods: {
    init(id) {
      this.dataForm.taskId = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.taskId) {
         taskInfoData(this.dataForm.taskId).then(data => {
            if (data && data.code === 0) {
              this.dataForm.bannerName = data.sysBanner.bannerName;
              this.dataForm.bannerImg = data.sysBanner.bannerImg;
            } else {
              this.$message.error(data.msg);
            }
          });
        }else{
          this.dataForm = {}
        }
      });
    },
    // 获取图片路径
    getImgUrl(value){
      debugger
      this.dataForm.bannerImg = JSON.parse(JSON.stringify(value))
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let psotData = {
              bannerName: this.dataForm.bannerName,
              bannerImg: this.dataForm.bannerImg
          };
         bannerSaveData(psotData).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .form{
    ::v-deep .el-input.is-disabled .el-input__inner{
      color: #000 !important;
    }
  }
</style>